// app/validaTimeSheet/validaTimeSheet.js

(function () {
    'use strict';
    var controllerId = 'validaTimeSheet';
    angular.module('app').controller(controllerId, ['$rootScope', 'datacontext', 'common', 'sectionMenu', '_', 'moment', 'bootstrap.dialog', '$uibModal', '$filter', '$location', validaTimeSheetFn]);

    function validaTimeSheetFn($rootScope, datacontext, common, sectionMenu, _, moment, bDialog, $uibModal, $filter, $location) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 
        var detectIE = $rootScope.detectIE;

        var vm = this;
        vm.title = 'Validazione Timesheet';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection('ValidaTimeSheet');
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        vm.valida = true;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Nominativo', 'Matricola', 'Sezione', 'Data crescente', 'Data decrescente'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Elenchi dettaglio
        vm.list.sezioni = [];
        vm.list.profili = [];           //Profili orari del dipendente
        vm.list.profiloOre = [];        //Elenco profili orari generale

        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = 1;
        vm.filter.convalidato = vm.fConvalidato = 0
        vm.filter.sezione = vm.fSezione = 0;
        vm.filter.ricerca = vm.fRicerca = '';
        vm.fData = new Date();
        vm.filter.data = $filter('date')(vm.fData, 'dd/MM/yyyy');
        //var d = new Date();
        //vm.filter.data = vm.fData = '';

        //Configurazione calendario
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        vm.format = 'dd/MM/yyyy';

        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened1 = false;
        };

        vm.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = !vm.opened1;
            vm.opened = false;
        };

        //Metodi su interfaccia
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.notifica = notifica;
        vm.notificaTutti = notificaTutti;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getSezioni(), getProfiloOre()];
            common.activateController(promises, controllerId)
                .then(function () {
                    datacontext.timeSheet_getDate().then(function (data) {
                        if (data) {
                            //d = new Date(data);
                            //vm.fData = $filter('date')(d, 'dd/MM/yyyy');
                        }
                    });
                    //if ($routeParams.DipendenteId != null) {
                    //    setView('detail');
                    //    getRecord($routeParams.DipendenteId, 0);
                    //}
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.convalidato = vm.fConvalidato == null ? 1 : vm.fConvalidato;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.sezione = vm.fSezione == null ? 0 : vm.fSezione;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.data = vm.fData == null ? '' : $filter('date')(vm.fData, 'dd/MM/yyyy');
            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.validazioneTimeSheet_countAll(vm.filter.convalidato, vm.filter.stato, vm.filter.sezione, vm.filter.data, vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.validazioneTimeSheet_getAll(vm.pageSize, vm.page, vm.filter.convalidato, vm.filter.stato, vm.filter.sezione, vm.filter.data, vm.filter.ricerca, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function notifica(id) {
            datacontext.pushNotification_add(id, "L' utente %nominativo% richiede l'indicazione delle ore lavorate.").then(function (data) {
                if (!data)
                    logSuccess("Notifica inviata");
                else
                    logError("Errore durante l'invio della notifica");
            });

        }

        function notificaTutti() {
            var message = "L' utente %nominativo% richiede l'indicazione delle ore lavorate.";
            datacontext.validazioneTimeSheet_notificaTutti(0, $filter('date')(vm.fData, 'dd/MM/yyyy'), vm.fRicerca, message).then(function (data) {
                if (data == true)
                    logSuccess("Notifica inviata");
                else
                    logError("Errore durante l'invio delle notifiche");
            });
        }

        //Metodi su interfaccia
        function prevDay() {
            var data = new Date(vm.fData);
            data.setDate(data.getDate() - 1);
            vm.fData = data;
            cerca();
        }

        function nextDay() {
            var data = new Date(vm.fData);
            data.setDate(data.getDate() + 1);
            vm.fData = data;
            cerca();
        }

        //Get list
        function getSezioni() {
            return datacontext.sezione_getAllList().then(function (data) {
                return vm.list.sezioni = data;
            });
        }

        function getProfiloOre() {
            return datacontext.profiloOre_getAllList().then(function (data) {
                return vm.list.profiloOre = data;
            });
        }

        
    }
})();